module.exports = __webpack_public_path__ + "img/logo_tlv.4c2b33c7.png";